import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from "formik"
import * as Yup from "yup"
import * as icon from "@coreui/icons";
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'

// components
import AppCard from '../../components/AppCard'
import AppTable from '../../components/AppTable'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppForm from '../../components/form/form-employee/AppForm'
import ActionButtonForm from 'src/components/form/general-input-form/ActionButtonForm'
import AppModalConfirmation from '../../components/modal/AppModalConfirmation'
import AppModalFilePreview from 'src/components/modal/AppModalFilePreview';

// helpers
import Axios from '../../helpers/axios'
import { singleCountriesOptionsSelect, singleGenderOptionSelect, singleStatusContractOptionSelect, singleDegreeOptionsSelect, singleProjectsOptionsSelect, singleTypeSalaryDetailOptionSelect } from '../../helpers/format-options'
import { columnPayrollList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from 'src/helpers/format-queries'
import { capitalizeFirstLetter } from 'src/helpers/text-format';
import useToastMessage from 'src/helpers/toast-message'

const EditEmployee = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { showSuccess, showError } = useToastMessage();
  const params = useParams()
  const { id } = params

  const isLoading = useSelector((state) => state.isLoading)

  const [employeeDetail, setEmployeeDetail] = useState('')
  const [payrollDetail, setPayrollDetail] = useState('')

  const [countryOptions, setCountryOptions] = useState('')
  const [country, setCountry] = useState({})

  const [degreeOptions, setDegreeOptions] = useState('')
  const [projectOptions, setProjectOptions] = useState('')

  const [gender, setGender] = useState(null)
  const [statusContract, setStatusContract] = useState(null)
  const [projects, setProjects] = useState(null)

  const [showConfirmAddPayroll, setShowConfirmAddPayroll] = useState({ show: false, item: {}, backdrop: true })
  const [showConfirmAddAttachments, setShowConfirmAddAttachments] = useState({ show: false, item: {} })
  const [showConfirmAddPayrollAttachments, setShowConfirmAddPayrollAttachments] = useState({ show: false, item: {} })
  const [showConfirmAddPayrollSalarySlip, setShowConfirmAddPayrollSalarySlip] = useState({ show: false, item: {} })
  const [showConfirmDeleteAllPayroll, setShowConfirmDeleteAllPayroll] = useState({ show: false, item: {} })

  const [showDeleteItem, setShowDeleteItem] = useState({ show: false, type: '', item: {} })
  const [showConfirmEdit, setShowConfirmEdit] = useState({ show: false, type: '', item: {} })
  const [showConfirmView, setShowConfirmView] = useState({ show: false, type: '', item: {} }) 

  const [showModalConfirm, setShowModalConfirm] = useState({ show: false, type: '', text: '' })
  const [headerTitle, setHeaderTitle] = useState('')

  const [payrollList, setPayrollList] = useState([])
  const [payrollListCount, setPayrollListCount] = useState(0);
  const [payrollListPerPage, setPayrollListPerPage] = useState(10);
  const [activePayrollListPage, setActivePayrollListPage] = useState(1);
  const [searchPayrollListFilter, setSearchPayrollListFilter] = useState("");
  const [columnPayrollListSorter, setColumnPayrollListSorter] = useState({ column: "createdAt", state: "DESC" });

  const [firstLastDatePayroll, setFirstLastDatePayroll] = useState({
    first_payroll_date: null,
    last_payroll_date: null
  })

  const [isProcessingPayroll, setIsProcessingPayroll] = useState(false)

  const [openFilePreview, setOpenFilePreview] = useState(false)

  const lastAccordionSalaryDetailRef = useRef(null);
  const [shouldScroll, setShouldScroll] = useState(false);

  const [activeAccordionKey, setActiveAccordionKey] = useState(null)

  const formik = useFormik({
    initialValues: {
      employee_first_name: employeeDetail?.first_name,
      employee_last_name: employeeDetail?.last_name,
      employee_address: employeeDetail?.address,
      employee_id_card_number: employeeDetail?.nik,
      phone_number: employeeDetail?.contact_number,
      country_id: employeeDetail?.country?.id,
      is_contract_base: employeeDetail.is_contract_base,
      employee_contract_start_date: employeeDetail?.contract_start_date || '',
      employee_contract_end_date: employeeDetail?.contract_end_date || '',
      employee_gender: employeeDetail?.gender || '',
      employee_job_title: employeeDetail?.job_title || '',
      is_active: employeeDetail.is_active,
      employee_no: employeeDetail?.employee_no || '',
      employee_email_address: employeeDetail?.email_address,
      employee_place_of_birth: employeeDetail?.place_of_birth || '',
      employee_date_of_birth: employeeDetail?.date_of_birth || '',
      employee_status: employeeDetail?.status,
      employee_bpjs_kis_no: employeeDetail?.bpjs_kis_no || '',
      employee_register_date: employeeDetail?.register_date || '',
      employee_educations: employeeDetail?.educations?.length > 0 ? employeeDetail.educations : [
        {
          degree_type: null,
          field_of_study: '',
          institution_name: '',
          graduation_year: '',
          country_value: null
        }
      ],
      employee_accounts: employeeDetail?.accounts?.length > 0 ? employeeDetail.accounts : [
        {
          account_number: '',
          account_name: '',
          bank_name: '',
          bank_branch: '',
          is_main_account: false
        }
      ],
      employee_projects: employeeDetail?.employee_assignments || [],
      attachments: employeeDetail?.attachments || [],
      employee_notes: employeeDetail?.notes || '',
      employee_salary_details: employeeDetail?.salary_details?.length > 0 ? employeeDetail.salary_details : [
        {
          detail_name: 'Gaji Pokok',
          detail_value: '',
          is_deduction: false
        },
        {
          detail_name: 'Tunjangan Jabatan',
          detail_value: '',
          is_deduction: false
        },
        {
          detail_name: 'Tunjangan Transport',
          detail_value: '',
          is_deduction: false
        },
        {
          detail_name: 'Tunjangan Komunikasi',
          detail_value: '',
          is_deduction: false
        },
        {
          detail_name: 'Tunjangan Konsumsi',
          detail_value: '',
          is_deduction: false
        },
        {
          detail_name: 'Ekstra Insentif',
          detail_value: '',
          is_deduction: false
        }
      ],
      npwp_image: employeeDetail?.npwp_url ? [{
        file_url: employeeDetail?.npwp_url,
        file_original_name: employeeDetail?.npwp_original_name
      }] : [],
    },
    validationSchema: Yup.object().shape({
      employee_first_name: Yup.string()
        .required("Please enter first name."),
      employee_last_name: Yup.string()
        .required("Please enter last name."),
      employee_address: Yup.string()
        .required("Please enter address."),
      employee_id_card_number: Yup.string()
        .required("Please enter id card number."),
      phone_number: Yup.string()
        .required("Please enter contact number."),
      country_id: Yup.string().required("Please enter contact number country."),
      employee_contract_start_date: Yup.string()
        .when('is_contract_base', {
          is: true,
          then: () => Yup.string().required('Please select contract start date')
        }),
      employee_contract_end_date: Yup.string()
        .when('is_contract_base', {
          is: true,
          then: () => Yup.string().required('Please select contract end date')
        }),
      employee_email_address: Yup.string().required("Please enter email address."),
      employee_status: Yup.string().required("Please select status."),
      employee_register_date: Yup.string().required("Please select register date."),
      employee_job_title: Yup.string().required("Please enter job title/position."),
    }),
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      handleSave(values)
      setSubmitting(false)
    },
  });

  const formikPayroll = useFormik({
    initialValues: {
      payroll_date: payrollDetail?.date || '',
      payroll_value: payrollDetail?.value || '',
      payroll_tax_value: payrollDetail?.tax_value || '',
      payroll_bpjs_kesehatan: payrollDetail?.bpjs_kesehatan || '',
      payroll_bpjs_ketenagakerjaan: payrollDetail?.bpjs_ketenagakerjaan || '',
      files: payrollDetail?.attachments || [],
      salary_slip: payrollDetail?.salary_slip ? [payrollDetail?.salary_slip] : [],
      first_last_payroll_date: firstLastDatePayroll
    },
    validationSchema: Yup.object().shape({
      payroll_date: Yup.string()
        .required("Please enter payroll date."),
      payroll_value: Yup.string()
        .required("Please enter salary value."),
      payroll_tax_value: Yup.string()
        .required("Please enter salary tax"),
      payroll_bpjs_kesehatan: Yup.string()
        .required("Please enter value bpjs kesehatan."),
      payroll_bpjs_ketenagakerjaan: Yup.string()
        .required("Please enter value bpjs ketenagakerjaan."),
    }),
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      handleSavePayroll(values)
      setSubmitting(false)
    },
  });

  useEffect(() => {
    fetchAllCountries()
    fetchDetailEmployee()
    fetchAllDegree()
    fetchAllProject()
  }, [id]);

  useEffect(() => {
    const firstErrorKey = Object.keys(formik.errors)[0];
    
    if (firstErrorKey) {
      const errorElement = document.querySelector(`[id="${firstErrorKey}"]`);
      
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
        errorElement.focus();
      }
    }
  }, [formik.isSubmitting])

  useEffect(() => {
    getStatusProcessingPayroll()
  }, [])

  const handleQueriesPayroll = () => {
    let queries = {
      search: searchPayrollListFilter,
      limit: payrollListPerPage,
      offset: payrollListPerPage * activePayrollListPage - payrollListPerPage,
      sort:
        (columnPayrollListSorter &&
          `${columnPayrollListSorter.column}%${columnPayrollListSorter.state}`) ||
        "",
      employee_id: id
    };
    queries = formUrlQuery(queries);

    return queries
  }

  useEffect(() => {
    let queries = handleQueriesPayroll()
    fetchAllPayroll(queries)
  }, [
    searchPayrollListFilter,
    payrollListPerPage,
    activePayrollListPage,
    columnPayrollListSorter
  ])

  const fetchDetailEmployee = () => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/employee/${id}`,
    })
      .then(({ data }) => {
        const { success, value } = data || {}
        if (success) {
          setEmployeeDetail(value)
          setCountry(JSON.stringify({
            id: value?.country?.id,
            name: value?.country?.name,
            icon: icon[`cif${value?.country?.country_code}`],
            phone_code: value?.country?.phone_code
          }))
          if (value?.gender) {
            setGender({
              label: capitalizeFirstLetter(value?.gender),
              value: value?.gender
            })
          }
          if (value?.status) {
            setStatusContract({
              label: capitalizeFirstLetter(value?.status),
              value: value?.status
            })
          }
          setProjects(value?.employee_assignments)
          setActiveAccordionKey(value?.salary_details.length)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const fetchAllCountries = () => {
    Axios({
      method: "get",
      url: "/api/tracker/v1/countries",
    })
      .then(({ data }) => {
        setCountryOptions(singleCountriesOptionsSelect(data))
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  };

  const fetchAllPayroll = (queries) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/payroll?${queries}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setPayrollList(data?.value)
          if (activePayrollListPage === 1) {
            setPayrollListCount(data?.count)
          }
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const fetchAllDegree = () => {
    Axios({
      method: "get",
      url: "/api/tracker/v1/degree",
    })
      .then(({ data }) => {
        setDegreeOptions(singleDegreeOptionsSelect(data))
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const fetchAllProject = () => {
    Axios({
      method: "get",
      url: "/api/tracker/v1/project/option/list",
    })
      .then(({ data }) => {
        setProjectOptions(singleProjectsOptionsSelect(data?.value))
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const fetchLastPayroll = () => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/payroll?limit=1&offset=0&sort=createdAt%DESC&employee_id=${id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          let payrollVal = data?.value
          if (payrollVal?.length > 0) {
            setPayrollDetail(payrollVal[0])
          }
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const getStatusProcessingPayroll = () => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/payroll/processing-status/${id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          const employee = data?.value || {}
          employee?.is_processing_payroll ? setIsProcessingPayroll(true) : setIsProcessingPayroll(false)

          fetchAllPayroll(handleQueriesPayroll())
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handleSearchItemsPayroll = (search) => {
    setActivePayrollListPage(1)
    setSearchPayrollListFilter(search);
  }

  const handleOnDateChange = (date, name) => {
    if (name?.includes('employee')) {
      formik.setValues((values) => ({
        ...values,
        [name]: date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : ''
      }), false)
    } else {
      formikPayroll.setValues((values) => ({
        ...values,
        [name]: date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : ''
      }), false)
    }
  }

  const handleInputValue = (values) => {
    const formData = new FormData()
    formData.append('first_name', values.employee_first_name)
    formData.append('last_name', values.employee_last_name)
    formData.append('id_card_number', values.employee_id_card_number)
    formData.append('contact_number', values.phone_number)
    formData.append('address', values.employee_address)
    formData.append('country_id', values.country_id)
    formData.append('is_contract_base', values.is_contract_base)
    formData.append('is_active', values.is_active)
    formData.append('gender', values.employee_gender)
    formData.append('employee_no', values.employee_no)
    formData.append('email_address', values.employee_email_address)
    formData.append('place_of_birth', values.employee_place_of_birth)
    formData.append('date_of_birth', values.employee_date_of_birth)
    formData.append('status', values.employee_status)
    formData.append('bpjs_kis_no', values.employee_bpjs_kis_no)
    formData.append('register_date', values.employee_register_date)
    formData.append('contract_start_date', values.is_contract_base ? values.employee_contract_start_date : null)
    formData.append('contract_end_date', values.is_contract_base ? values.employee_contract_end_date : null)
    formData.append('notes', values.employee_notes)
    formData.append('job_title', values.employee_job_title)
    if (values?.attachments?.length > 0) {
      for (let i = 0; i < values.attachments.length; i++) {
        if (!values?.attachments[i]?.file_url && values?.attachments[i] instanceof File) {
          formData.append('file', values.attachments[i])
        }
      }
    }
    if (values?.employee_educations?.length > 0) {
      formData.append('educations', JSON.stringify(values.employee_educations))
    }
    if (values?.employee_projects?.length > 0) {
      formData.append('projects', JSON.stringify(values.employee_projects))
    }
    if (values?.employee_accounts?.length > 0) {
      formData.append('accounts', JSON.stringify(values.employee_accounts))
    }
    if (values?.employee_salary_details?.length > 0) {
      formData.append('salary_details', JSON.stringify(values.employee_salary_details))
    }
    if (values.npwp_image.length > 0) {
      if (!values?.npwp_image[0]?.file_url && values?.npwp_image[0] instanceof File) {
        formData.append('npwp', values.npwp_image[0])
      } else {
        formData.append('npwp', JSON.stringify(values.npwp_image))
      }
    } else {
      formData.append('npwp_image', JSON.stringify([]))
    }

    return formData
  }

  const handleInputValuePayroll = (values) => {
    const formData = new FormData()
    formData.append('employee_id', id)
    formData.append('date', values.payroll_date)
    formData.append('value', parseFloat(values?.payroll_value?.replace(/,/g, "")))
    formData.append('tax_value', parseFloat(values?.payroll_tax_value?.replace(/,/g, "")))
    formData.append('bpjs_kesehatan', parseFloat(values?.payroll_bpjs_kesehatan?.replace(/,/g, "")))
    formData.append('bpjs_ketenagakerjaan', parseFloat(values?.payroll_bpjs_ketenagakerjaan?.replace(/,/g, "")))
    if (values?.files?.length > 0) {
      for (let i = 0; i < values.files.length; i++) {
        if (!values?.files[i]?.file_url && values?.files[i] instanceof File) {
          formData.append('file', values.files[i])
        }
      }
    }
    if (values?.salary_slip?.length > 0) {
      for (let i = 0; i < values.salary_slip.length; i++) {
        if (!values?.salary_slip[i]?.file_url && values?.salary_slip[i] instanceof File) {
          formData.append('salary_slip', values.salary_slip[i])
        }
      }
    }

    return formData
  }

  const handlePost = (payload) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "post",
      url: `/api/tracker/v1/employee/update/${id}`,
      data: payload
    })
      .then(({ data }) => {
        if (data?.success) {
          showSuccess('Employee has been successfully updated')
          navigate(`/employee/details/${id}`)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handlePostPayroll = (payload) => {
    let url = `/api/tracker/v1/payroll`
    let actionName = 'created'

    if (headerTitle?.toLocaleLowerCase().includes('add')) {
      url += '/create'
    } else if (headerTitle?.toLocaleLowerCase().includes('bulk')) {
      url += `/update/bulk/${id}`
      actionName = 'bulk updated'
    } else {
      url += `/update/${payrollDetail?.id}`
      actionName = 'updated'
    }

    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "post",
      url: url,
      data: payload
    })
      .then(({ data }) => {
        if (data?.success) {
          setShowConfirmAddPayroll({ show: false, item: {}, backdrop: true })
          setHeaderTitle('')
          setPayrollDetail(null)
          formikPayroll.resetForm()
          
          if (actionName === 'created' || actionName === 'bulk updated') {
            if (data?.status === 'processing') {
              showSuccess(`Payroll has been processing ${actionName}`)
              setIsProcessingPayroll(true)
              
              window.location.reload()
            }
          } else {
            fetchAllPayroll(handleQueriesPayroll())
            showSuccess(`Payroll has been successfully updated`)
          }
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handleSave = (values) => {
    const inputPayload = handleInputValue(values)
    handlePost(inputPayload)
  }

  const handleSavePayroll = (values) => {
    const inputPayload = handleInputValuePayroll(values)
    handlePostPayroll(inputPayload)
  }

  const handleCardHeaderButton = () => {
    setShowConfirmAddAttachments({ show: true, item: {} })
  }

  const handleCardHeaderButtonPayrollAttachments = (name) => {
    if (name == 'payroll_attachments') {
      setShowConfirmAddPayrollAttachments({ show: true, item: {} })
    }
    if (name == 'payroll_salary_slip') {
      setShowConfirmAddPayrollSalarySlip({ show: true, item: {} })
    }
  }

  const handleFileInput = (values, type) => {
    const files = values

    if (files) {
      if (type?.includes('employee')) {
        formik.setValues((prevValues) => ({
          ...prevValues,
          attachments: [...prevValues['attachments'], ...files]
        }), false)
        
        setShowConfirmAddAttachments({ show: false, item: {} })
      }

      if (type?.includes('payroll')) {
        if (type == 'payroll_attachments') {
          formikPayroll.setValues((prevValues) => ({
            ...prevValues,
            files: [...prevValues['files'], ...files]
          }), false)
  
          setShowConfirmAddPayrollAttachments({ show: false, item: {} })
        }
        if (type == 'payroll_salary_slip') {
          formikPayroll.setValues((prevValues) => ({
            ...prevValues,
            salary_slip: [...prevValues['salary_slip'], ...files]
          }), false)
  
          setShowConfirmAddPayrollSalarySlip({ show: false, item: {} })
        }
      }
    }
  }

  const handleRemoveFile = (index = 0, name) => {
    let prevValue;

    let isDeleted = false
    let url = '/api/tracker/v1/'
    let successMsg = 'File has been successfully deleted'
    let isAutoReload = true

    if (name?.includes('employee')) {
      prevValue = formik.values['attachments'][index]
    } else if (name?.includes('npwp')) {
      prevValue = formik.values['npwp_image'][index]
    } else {
      if (name === 'payroll_attachments') {
        prevValue = formikPayroll.values['files'][index]
      }
      if (name === 'payroll_salary_slip') {
        prevValue = formikPayroll.values['salary_slip'][index]
      }
    }

    if (prevValue?.file_url) {
      if (name === 'employee_attachments') {
        isDeleted = true
        url += `employee/delete/employeeattachment/${prevValue?.id}`
      }

      if (name === 'payroll_attachments') {
        isDeleted = true
        url += `payroll/delete/payrollattachment/${prevValue?.id}`
      }

      if (name === 'payroll_salary_slip') {
        isDeleted = true
        url += `payroll/delete/payrollsalaryslip/${prevValue?.id}`
        successMsg = 'Salary slip has been successfully deleted'
      }
    } else {
      if (name === 'payroll') {
        isDeleted = true
        url += `payroll/delete/${showDeleteItem?.item?.id}`
        successMsg = 'Payroll has been successfully deleted'
      }
      if (name === 'employee_educations') {
        isDeleted = true
        url += `employee/delete/employeeeducation/${showDeleteItem?.item?.id}`
        successMsg = 'Education has been successfully deleted'
      }
      if (name === 'employee_accounts') {
        isDeleted = true
        url += `employee/delete/employeeaccount/${showDeleteItem?.item?.id}`
        successMsg = 'Bank account has been successfully deleted'
      }
      if (name === 'employee_salary_details') {
        isDeleted = true
        url += `employee/delete/employeesalarydetail/${showDeleteItem?.item?.id}`
        successMsg = 'Salary detail has been successfully deleted'
        isAutoReload = false
      }
    }

    if (isDeleted) {
      dispatch({
        type: 'SET_IS_LOADING',
        isLoading: true
      })
      Axios({
        method: "delete",
        url,
      })
        .then(({ data }) => {
          if (data?.success) {
            showSuccess(successMsg)
            if (isAutoReload) {
              window.location.reload()
            }
          }
        })
        .catch((err) => {
          console.error(err);
          const errMsg = err?.response?.data?.message
          showError(errMsg)
        })
        .finally(() => {
          dispatch({
            type: 'SET_IS_LOADING',
            isLoading: false
          })
        })
    } else {
      if (name?.includes('employee')) {
        formik.setValues((values) => ({
          ...values,
          attachments: values['attachments']?.filter((_, i) => i !== index)
        }), false)
      }
  
      if (name?.includes('payroll')) {
        if (name == 'payroll_attachments') {
          formikPayroll.setValues((values) => ({
            ...values,
            files: values['files']?.filter((_, i) => i !== index)
          }), false)
        }
        if (name == 'payroll_salary_slip') {
          formikPayroll.setValues((values) => ({
            ...values,
            salary_slip: values['salary_slip']?.filter((_, i) => i !== index)
          }), false)
        }
      }

      if (name?.includes('npwp')) {
        formik.setValues((values) => ({
          ...values,
          npwp_image: values['npwp_image']?.filter((_, i) => i !== index)
        }), false)
      }
    }

    if (showDeleteItem?.hasOwnProperty('otherFunc')) {
      showDeleteItem.otherFunc()
    }

    setShowDeleteItem({ show: false, type: '', item: {}, index: 0 })
  }

  const handleImagesOnDrop = (files) => {
    const attachments = []
    if (files[0] && typeof files[0] !== 'undefined') {
      attachments.push(files[0])
      formik.setValues((values) => ({
        ...values,
        npwp_image: attachments
      }), false)
    }
  }

  const handleImageAttachment = (e) => {
    e.preventDefault()
    const files = e.target.files
    const attachments = []
    if (files[0] && typeof files[0] !== 'undefined') {
      attachments.push(files[0])
      formik.setValues((values) => ({
        ...values,
        npwp_image: attachments
      }), false)
    }
  }

  const handleDeleteAllPayroll = () => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "delete",
      url: `/api/tracker/v1/payroll/delete/employee/${id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setShowConfirmDeleteAllPayroll({ show: false, item: {} })

          if (data?.status == 'processing') {
            showSuccess('All payroll has been processing deleted')
            setIsProcessingPayroll(true)

            window.location.reload()
          }
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handleGetFirstLastDatePayroll = () => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/payroll/first-last-date/${id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setFirstLastDatePayroll(data?.value)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  useEffect(() => {
    if (showConfirmEdit.show) {
      if (showConfirmEdit.type === 'payroll') {
        setPayrollDetail(showConfirmEdit.item)
        setShowConfirmAddPayroll({ show: true, item: {}, backdrop: true })
        setHeaderTitle('Edit Payroll')
      }
    }
  }, [showConfirmEdit])

  useEffect(() => {
    if (showConfirmView?.show) {
      if (showConfirmView?.type === 'payroll') {
        setPayrollDetail(showConfirmView.item)
      }
    }
  }, [showConfirmView])

  const handleShowModalCreateNewPayroll = () => {
    let payloadShowConfirm = { show: true, item: {}, backdrop: 'static' }
    
    if (payrollList?.length > 0) {
      setHeaderTitle('Edit Bulk Payroll')
      fetchLastPayroll()
      handleGetFirstLastDatePayroll()
    } else {
      setHeaderTitle('Add Payroll')
    }

    setShowConfirmAddPayroll(() => ({
      ...payloadShowConfirm
    }))
  }

  const handleShowModalDeleteAllPayroll = () => {
    setShowConfirmDeleteAllPayroll({ show: true, item: {} })
  }

  const handleSubmit = () => {
    if (showModalConfirm.type === 'employee') {
      formik.handleSubmit()
    }

    if (showModalConfirm.type === 'payroll') {
      formikPayroll.handleSubmit()
    }

    setShowModalConfirm({ show: false, type: '', text: '' })
  }

  const handleSelectCountry = (data) => {
    formik.setValues((values) => ({
      ...values,
      country_id: data ? JSON.parse(data?.value).id : ''
    }), false)

    setCountry(data? data?.value : null)
  }

  const handleSelectGender = (data) => {
    formik.setValues((values) => ({
      ...values,
      employee_gender: data ? data?.value : ''
    }), false)

    setGender(data ? data : null)
  }

  const handleSelectStatusContract = (data) => {
    formik.setValues((values) => ({
      ...values,
      employee_status: data ? data?.value : '',
      is_contract_base: data ? data?.value == 'full-time' ? false : true : false
    }))

    setStatusContract(data ? data : null)
  }

  const handleSelectProject = (data) => {
    formik.setValues((values) => ({
      ...values,
      employee_projects: data ? data : []
    }), false)

    setProjects(data ? data : [])
  }

  const handleAddEmployeeEducations = () => {
    formik.setValues((values) => ({
      ...values,
      employee_educations: [
        ...values.employee_educations,
        ...[
          {
            degree_type: null,
            field_of_study: '',
            institution_name: '',
            graduation_year: '',
            country_value: null
          }
        ]
      ]
    }), false)
  }

  const handleAddEmployeeAccounts = () => {
    formik.setValues((values) => ({
      ...values,
      employee_accounts: [
        ...values.employee_accounts,
        ...[
          {
            account_number: '',
            account_name: '',
            bank_name: '',
            bank_branch: '',
            is_main_account: false
          }
        ]
      ]
    }), false)
  }

  const handleAddEmployeeSalaryDetails = () => {
    setShouldScroll(true);
    formik.setValues((values) => {
      const updated = [
        ...values.employee_salary_details,
        {
          detail_name: '',
          detail_value: '',
          is_deduction: false
        }
      ]

      // Set accordion baru sebagai aktif
      setActiveAccordionKey(updated.length)

      return {
        ...values,
        employee_salary_details: updated
      }
    }, false)
  }

  const handleChangeEducation = (e, informationIndex) => {
    const name = e?.target?.name
    const value = e?.target?.value

    formik.setValues((values) => {
      const newArrayInformation = values.employee_educations.map((item, itemIndex) => {
        if (itemIndex == informationIndex) {
          return {
            ...item,
            [name]: value
          };
        } else {
          return item;
        }
      });

      return {
        ...values,
        employee_educations: [
          ...newArrayInformation,
        ]
      }
    }, false)
  }

  const handleChangeAccount = (e, informationIndex) => {
    const name = e?.target?.name || e?.target?.id
    const value = e?.target?.value
    const checked = e?.target?.checked

    formik.setValues((values) => {
      const newArrayInformation = values.employee_accounts.map((item, itemIndex) => {
        if (itemIndex == informationIndex) {
          return {
            ...item,
            [name]: name == 'is_main_account' ? checked : value
          };
        } else {
          if (name === 'is_main_account') {
            return {
              ...item,
              [name]: false
            }
          } else {
            return item;
          }
        }
      });

      return {
        ...values,
        employee_accounts: [
          ...newArrayInformation,
        ]
      }
    }, false)
  }

  const handleChangeSalaryDetails = (e, informationIndex, name = null) => {
    const targetName = e?.target?.name || e?.target?.id || name
    const value = e?.target?.value
    const valueObj = e?.value
    
    formik.setValues((values) => {
      const newArrayInformation = values.employee_salary_details.map((item, itemIndex) => {
        if (itemIndex == informationIndex) {
          return {
            ...item,
            [targetName]: targetName == 'is_deduction' ? valueObj : value
          };
        } else {
          return item;
        }
      });

      return {
        ...values,
        employee_salary_details: [
          ...newArrayInformation,
        ]
      }
    }, false)
  }

  const handleSelectEducation = (data, name, informationIndex) => {
    formik.setValues((values) => {
      const newArrayInformation = values.employee_educations.map((item, itemIndex) => {
        if (itemIndex == informationIndex) {
          return {
            ...item,
            [name]: name == 'country_value' ? data ? {
              label: data?.label,
              value: JSON.parse(data?.value)?.id
            } : null : data ? data : null
          };
        } else {
          return item;
        }
      });

      return {
        ...values,
        employee_educations: [
          ...newArrayInformation,
        ]
      }
    }, false)
  }

  const handleRemoveEmployeeEducation = (data, index) => {
    if (data?.id) {
      setShowDeleteItem({ show: true, item: data, type: 'employee_educations', index })
    } else {
      formik.setValues((values) => ({
        ...values,
        employee_educations: values.employee_educations.filter((_, itemIndex) => itemIndex !== index)
      }), false)
    }
  }

  const handleRemoveEmployeeAccount = (data, index) => {
    if (data?.id) {
      setShowDeleteItem({ show: true, item: data, type: 'employee_accounts', index })
    } else {
      formik.setValues((values) => ({
        ...values,
        employee_accounts: values.employee_accounts.filter((_, itemIndex) => itemIndex !== index)
      }), false)
    }
  }

  const handleRemoveEmployeeSalaryDetails = (data, index) => {
    if (data?.id) {
      setShowDeleteItem({ show: true, item: data, type: 'employee_salary_details', index, otherFunc: () => handleRemoveEmployeeSalaryDetails(null, index)})
    } else {
      formik.setValues((values) => {
        const updated = values.employee_salary_details.filter((_, i) => i !== index)

        // Atur activeAccordionKey
        if (activeAccordionKey === index + 1) {
          // Jika yang dihapus adalah accordion aktif
          const nextAccordion = index + 1 <= updated.length
            ? index + 1
            : index
          setActiveAccordionKey(updated.length > 0 ? nextAccordion : null)
        } else if (activeAccordionKey > index + 1) {
          // Geser key aktif ke atas 1 posisi
          setActiveAccordionKey((prevKey) => prevKey - 1)
        }

        return {
          ...values,
          employee_salary_details: updated
        }
      }, false)
    }
  }

  const handleOnRowPayrollClick = (item, columnName) => {
    if (columnName !== 'action') {
      setShowConfirmView({ show: true, type: 'payroll', item })
    }
  }

  useEffect(() => {
    if (shouldScroll && lastAccordionSalaryDetailRef.current) {
      lastAccordionSalaryDetailRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      setShouldScroll(false);
    }
  }, [formik.values.employee_salary_details, shouldScroll]);

  return (
    <>
      {openFilePreview && (
        <AppModalFilePreview
          setOpenFilePreview={setOpenFilePreview}
          file={openFilePreview}
        />
      )}
      {
        showConfirmAddPayroll.show && (
          <AppModalConfirmation 
            confirmationType='add-payroll'
            itemName='add-payroll'
            headerTitle={headerTitle}
            showModal={showConfirmAddPayroll}
            setShowModal={setShowConfirmAddPayroll}
            values={formikPayroll.values}
            errors={formikPayroll.errors}
            handleChange={formikPayroll.handleChange}
            handleFileInput={handleFileInput}
            handleOnDateChange={handleOnDateChange}
            handleSubmit={() => setShowModalConfirm({ show: true, type: 'payroll', text: headerTitle?.toLocaleLowerCase().includes('add') ? 'Are you sure want to create a new payroll?' : headerTitle?.toLocaleLowerCase().includes('bulk') ? 'Are you sure want to edit bulk payroll for this employee?' : 'Are you sure want to edit this payroll?' })}
            handleConfirmDelete={setShowDeleteItem}
            handleCardHeaderButton={handleCardHeaderButtonPayrollAttachments}
            handleViewFile={setOpenFilePreview}
            isLoading={isLoading}
          />
        )
      }
      {
        showConfirmView.show && showConfirmView?.type === 'payroll' && (
          <AppModalConfirmation 
            confirmationType='detail-payroll'
            itemName="detail-payroll"
            itemDetails={showConfirmView.item}
            itemType={showConfirmView.type}
            showModal={showConfirmView}
            setShowModal={setShowConfirmView}
            handleViewFile={setOpenFilePreview}
          />
        )
      }
      {
        showConfirmAddAttachments.show && (
          <AppModalConfirmation 
            confirmationType='add-attachments'
            itemName='employee_attachments'
            itemDetails={showConfirmAddAttachments.item}
            showModal={showConfirmAddAttachments}
            setShowModal={setShowConfirmAddAttachments}
            errors={formik.errors?.attachments}
            handleChange={formik.handleChange}
            handleFileInput={handleFileInput}
            headerTitle={`Add Employee Attachments`}
          />
        )
      }
      {
        showConfirmAddPayrollAttachments.show && (
          <AppModalConfirmation 
            confirmationType='add-attachments'
            itemName='payroll_attachments'
            itemDetails={showConfirmAddPayrollAttachments.item}
            showModal={showConfirmAddPayrollAttachments}
            setShowModal={setShowConfirmAddPayrollAttachments}
            errors={formikPayroll.errors?.files}
            handleChange={formikPayroll.handleChange}
            handleFileInput={handleFileInput}
            headerTitle={`Add Payroll Attachments`}
          />
        )
      }
      {
        showConfirmAddPayrollSalarySlip.show && (
          <AppModalConfirmation 
            confirmationType='add-attachments'
            itemName='payroll_salary_slip'
            itemDetails={showConfirmAddPayrollSalarySlip.item}
            showModal={showConfirmAddPayrollSalarySlip}
            setShowModal={setShowConfirmAddPayrollSalarySlip}
            errors={formikPayroll.errors?.salary_slip}
            handleChange={formikPayroll.handleChange}
            handleFileInput={handleFileInput}
            headerTitle={`Add Payroll Salary Slip`}
          />
        )
      }
      {
        showConfirmDeleteAllPayroll.show && (
          <AppModalConfirmation 
            confirmationType='delete-all-payroll'
            itemDetails={showConfirmDeleteAllPayroll.item}
            itemType={'payroll'}
            showModal={showConfirmDeleteAllPayroll}
            setShowModal={setShowConfirmDeleteAllPayroll}
            handleConfirmation={handleDeleteAllPayroll}
            isLoading={isLoading}
          />
        )
      }
      {
        showDeleteItem.show && (
          <AppModalConfirmation 
            confirmationType='delete-item'
            itemName={`${showDeleteItem.type === 'payroll' ? `Payroll-${moment(showDeleteItem?.item?.date).format('DD/MM/YYYY')}` : showDeleteItem.type == 'employee_educations' ? `Education ${showDeleteItem.index+1}` : showDeleteItem.type == 'employee_accounts' ? `Account ${showDeleteItem.index+1}` : showDeleteItem.type == 'employee_salary_details' ? `Salary Details ${showDeleteItem.index+1}` : showDeleteItem?.item?.file_original_name ? showDeleteItem?.item?.file_original_name : showDeleteItem?.item?.name}`}
            itemDetails={showDeleteItem.item}
            itemType={showDeleteItem.type}
            itemIndex={showDeleteItem?.index}
            showModal={showDeleteItem}
            setShowModal={setShowDeleteItem}
            handleConfirmation={handleRemoveFile}
            isLoading={isLoading}
          />
        )
      }
      {
        showModalConfirm.show && (
          <AppModalConfirmation 
            confirmationType="confirmation"
            showModal={showModalConfirm}
            setShowModal={setShowModalConfirm}
            headerTitle="Confirmation"
            descriptionText={showModalConfirm.text}
            handleSubmit={handleSubmit}
            disabled={formik.isSubmitting}
            isLoading={isLoading}
          />
        )
      }
      <AppCard 
        className='mb-4'
        headerTitle={<h4>Edit Employee</h4>}
        bodyContent={
          <AppForm 
            values={formik.values}
            handleChange={formik.handleChange}
            errors={formik.errors}
            countryOptions={countryOptions}
            setCountry={setCountry}
            country={country}
            handleSelectCountry={handleSelectCountry}
            onDateChange={handleOnDateChange}
            genderOptions={singleGenderOptionSelect()}
            gender={gender}
            handleSelectGender={handleSelectGender}
            statusContractOptions={singleStatusContractOptionSelect()}
            statusContract={statusContract}
            handleSelectStatusContract={handleSelectStatusContract}
            degreeOptions={degreeOptions}
            projectOptions={projectOptions}
            handleAddEmployeeEducations={handleAddEmployeeEducations}
            handleChangeEducation={handleChangeEducation}
            handleSelectEducation={handleSelectEducation}
            handleRemoveEmployeeEducation={handleRemoveEmployeeEducation}
            handleSelectProject={handleSelectProject}
            projects={projects}
            handleAddEmployeeAccounts={handleAddEmployeeAccounts}
            handleChangeAccount={handleChangeAccount}
            handleRemoveEmployeeAccount={handleRemoveEmployeeAccount}
            handleAddEmployeeSalaryDetails={handleAddEmployeeSalaryDetails}
            handleChangeSalaryDetails={handleChangeSalaryDetails}
            handleRemoveEmployeeSalaryDetails={handleRemoveEmployeeSalaryDetails}
            handleRemoveImage={setShowDeleteItem}
            handleFileInput={handleImageAttachment}
            handleFileOnDrop={handleImagesOnDrop}
            setOpenFilePreview={setOpenFilePreview}
            salaryTypeOptions={singleTypeSalaryDetailOptionSelect()}
            handleCardHeaderButton={handleCardHeaderButton}
            handleConfirmDelete={setShowDeleteItem}
            lastAccordionSalaryDetailRef={lastAccordionSalaryDetailRef}
            activeAccordionKey={activeAccordionKey}
            setActiveAccordionKey={setActiveAccordionKey}
          />
        }
        lowerBodyContent={
          <>
            <AppCard
              className='mt-4 mb-4'
              headerTitle={
                <AppCardHeader
                  headerTitle={<h4>Payrolls</h4>}
                  headerButton={payrollList?.length === 0 ? 'Create new payroll' : 'Edit bulk payroll'}
                  handleCardHeaderButton={handleShowModalCreateNewPayroll}
                  headerOtherButton={payrollList?.length === 0 ? null : 'Delete all payroll'}
                  handleCardHeaderOtherButton={handleShowModalDeleteAllPayroll}
                />
              }
              bodyContent={
                <AppTable
                  payrollListPage
                  tableFilter
                  tableColumns={columnPayrollList}
                  tableContent={payrollList}
                  isShowModalEdit={true}
                  contentPerPage={payrollListPerPage}
                  contentCount={payrollListCount}
                  activeContentPage={activePayrollListPage}
                  searchContentFilter={searchPayrollListFilter}
                  setShowConfirmEdit={setShowConfirmEdit}
                  setShowConfirmDelete={setShowDeleteItem}
                  setSearchContentFilter={handleSearchItemsPayroll}
                  setActiveContentPage={setActivePayrollListPage}
                  setContentPerPage={setPayrollListPerPage}
                  setColumnContentSorter={setColumnPayrollListSorter}
                  handleOnRowClick={handleOnRowPayrollClick}
                  isClickable={true}
                  isShowTextProcessing={isProcessingPayroll}
                />
              }
            />
          </>
        }
        footerContent={
          <ActionButtonForm
            isLoading={isLoading}
            disabled={formik.isSubmitting}
            onCancel={() => navigate(`/employee/details/${id}`)}
            onSave={() => setShowModalConfirm({ show: true, type: 'employee', text: "Are you sure want to edit this employee?" })}
          />
        }
      />
    </>
  )
}

export default EditEmployee